import { LoadingInterstitial } from "swing-components";

/** Centered Loader */
export function Loader() {
  return (
    <div css={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <LoadingInterstitial />
    </div>
  );
}
